export const styles = {
  detailContent: 'tw-flex tw-flex-col tw-gap-4',
};
